import styled from 'styled-components';
import React from 'react';

const StyledChecklist = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export type ChecklistProps = {
  /**
   * Class name for additional styling; used to pass down styles when using inheritance in styled components
   */
  className?: string;
  /**
   * Children of the component - typically ChecklistItem components
   */
  children: React.ReactNode;
};

/**
 * A checklist component for displaying a list of items with checkmark icons.
 * Use with ChecklistItem components as children.
 */
export const Checklist = ({ className, children }: ChecklistProps) => {
  return <StyledChecklist className={className}>{children}</StyledChecklist>;
};

export default Checklist;
